import {
  WSButton,
  WSCard,
  WSElement,
  WSElementProps,
  WSFlexBox,
  WSText
} from "@wingspanhq/fe-component-library";
import queryString from "qs";
import { useHistory } from "react-router-dom";
import { useFeatureFlags } from "../../../../query/hooks/useFeatureFlags";
import { useQueryPaymentsStatus } from "../../../../query/payments/queries";
import { components } from "../../../../services/api/banking/types";
import { openInNewTab } from "../../../../shared/utils/openInNewTab";
import { WS_LINKS } from "../../../../types/wsLinks";

type Props = WSElementProps & {
  accountType?: components["schemas"]["InternalAccountType"];
};

export const WingspanAccounts: React.FC<Props> = ({
  accountType,
  ...props
}) => {
  const featureFlags = useFeatureFlags();
  const history = useHistory();
  const queryPaymentsStatus = useQueryPaymentsStatus();
  const handleDepositAccountLimits = () => {
    const url = queryPaymentsStatus.data?.bankingAccountTier
      ? (WS_LINKS.depositLimit as any)[
          queryPaymentsStatus.data?.bankingAccountTier
        ]
      : undefined;
    openInNewTab(url ?? "https://wingspan.app");
  };

  return (
    <WSElement {...props}>
      <WSText.Paragraph weight="medium" mb="L">
        Wingspan accounts
      </WSText.Paragraph>

      <WSCard>
        <WSText.ParagraphSm color="gray500">
          Wingspan manages a bank account on your behalf for accepting bank
          transfer payments and tax withholdings.
        </WSText.ParagraphSm>

        <WSFlexBox direction="column" gap="XS" mt="L">
          <WSButton.Link
            size="S"
            onClick={() => {
              history.push({
                pathname: "/member/statements",
                search: accountType
                  ? queryString.stringify({
                      accountType: [accountType]
                    })
                  : undefined
              });
            }}
          >
            View Statements
          </WSButton.Link>
          <WSButton.Link
            size="S"
            onClick={() =>
              openInNewTab(WS_LINKS.electronicDisclosureAndConsent)
            }
          >
            Electronic Consent Disclosure
          </WSButton.Link>
          <WSButton.Link
            size="S"
            onClick={() => openInNewTab(WS_LINKS.depositAccountTermsConditions)}
          >
            Deposit Account Terms
          </WSButton.Link>
          <WSButton.Link size="S" onClick={handleDepositAccountLimits}>
            Deposit Account Limits
          </WSButton.Link>
        </WSFlexBox>
      </WSCard>
    </WSElement>
  );
};
